import React from "react";
import { View, StyleSheet, ViewStyle, StyleProp } from "react-native";

export const TABLE_END_WIDTH = 37;

export type TableEndProps = {
  borderColor?: string;
  style?: StyleProp<ViewStyle>;
  children?: React.ReactNode;
};

export function TableEnd({ borderColor, style, children }: TableEndProps) {
  return <View style={[styles.end, { borderColor }, style]}>{children}</View>;
}

const styles = StyleSheet.create({
  end: {
    flexDirection: "row",
    height: "100%",
    width: TABLE_END_WIDTH,
    justifyContent: "center",
    alignItems: "center",
    gap: 4,
    borderLeftWidth: 1,
    borderTopRightRadius: 6,
    borderBottomRightRadius: 6,
    paddingHorizontal: 4,
  },
});
